<script>
export default {
  name: 'InfoCircle',
  props: {
    size: {
      type: [Number, String],
      default: 15,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 1.25C4.05625 1.25 1.25 4.05625 1.25 7.5C1.25 10.9438 4.05625 13.75 7.5 13.75C10.9438 13.75 13.75 10.9438 13.75 7.5C13.75 4.05625 10.9438 1.25 7.5 1.25ZM7.03125 5C7.03125 4.74375 7.24375 4.53125 7.5 4.53125C7.75625 4.53125 7.96875 4.74375 7.96875 5V8.125C7.96875 8.38125 7.75625 8.59375 7.5 8.59375C7.24375 8.59375 7.03125 8.38125 7.03125 8.125V5ZM8.075 10.2375C8.04375 10.3187 8 10.3812 7.94375 10.4437C7.88125 10.5 7.8125 10.5437 7.7375 10.575C7.6625 10.6062 7.58125 10.625 7.5 10.625C7.41875 10.625 7.3375 10.6062 7.2625 10.575C7.1875 10.5437 7.11875 10.5 7.05625 10.4437C7 10.3812 6.95625 10.3187 6.925 10.2375C6.89375 10.1625 6.875 10.0813 6.875 10C6.875 9.91875 6.89375 9.8375 6.925 9.7625C6.95625 9.6875 7 9.61875 7.05625 9.55625C7.11875 9.5 7.1875 9.45625 7.2625 9.425C7.4125 9.3625 7.5875 9.3625 7.7375 9.425C7.8125 9.45625 7.88125 9.5 7.94375 9.55625C8 9.61875 8.04375 9.6875 8.075 9.7625C8.10625 9.8375 8.125 9.91875 8.125 10C8.125 10.0813 8.10625 10.1625 8.075 10.2375Z"
      :fill="color"
    />
  </svg>
</template>
